import { colors } from "widgets/utils";

import { useGenomeViewerStore } from "../../store/store.ts";
import { AnchorPoint } from "./AnchorPoint.tsx";
import { useGroupHeight } from "./hooks/use-group-height.ts";
import { useGroupPosition } from "./hooks/use-groups-position.ts";
import { MIN_TRACKGROUP_WIDTH, REGION_INDICATOR_OVERLAP, SVG_STYLES } from "./settings.ts";
import { TrackGroupItem } from "./TrackGroupItem.tsx";

interface TrackGroupOverviewProps {
  scale: number;
  panelWidth: number;
}

export const TrackGroupOverview = ({ scale, panelWidth }: TrackGroupOverviewProps) => {
  const groupHeight = useGroupHeight();
  const groups = useGroupPosition(scale, groupHeight);
  const hoveredGroupId = useGenomeViewerStore((state) => state.hoveredGroupId);

  return (
    <g transform={`translate(0, ${REGION_INDICATOR_OVERLAP / 2})`}>
      {groups.map(({ x, y, groupId }) => {
        const isGroupHovered = hoveredGroupId === groupId;
        return (
          <g key={`contig-overview-${groupId}`}>
            {isGroupHovered && (
              <rect
                x={(SVG_STYLES.group.strokeWidth / 2) % 2}
                y={y + (SVG_STYLES.group.strokeWidth % 2)}
                width={panelWidth}
                height={groupHeight - (SVG_STYLES.group.strokeWidth % 2)}
                {...SVG_STYLES.hoverGroup}
                fill={colors.primaryPale + "6F"}
              />
            )}
            <g
              transform={`translate(${Math.min(x, panelWidth - MIN_TRACKGROUP_WIDTH - SVG_STYLES.group.strokeWidth)} ${y})`}
              data-testid={`contig-overview-${groupId}`}
            >
              <TrackGroupItem groupId={groupId} scale={scale} panelWidth={panelWidth} isGroupHovered={isGroupHovered} />
              <AnchorPoint groupId={groupId} scale={scale} />
            </g>
          </g>
        );
      })}
    </g>
  );
};
